import { gql } from '@apollo/client'

const UPDATE_LOCATION_TYPE_CATEGORY_DETAILS_MUTATION = gql`
  mutation updateLocationTypeCategoryDetails(
    $id: ID!
    $data: LocationTypeCategoryDetailsInput!
  ) {
    updateLocationTypeCategoryDetails(id: $id, data: $data) {
      id
      description
      position
      isMain
      updatedAt
      updatedBy {
        id
        name
      }
    }
  }
`

export default UPDATE_LOCATION_TYPE_CATEGORY_DETAILS_MUTATION
